import fal from './fal';
import fas from './fas';
import far from './far';
import fab from './fab';

export default [...fal, ...fas, ...far, ...fab];
